import {Stack, Typography} from "@mui/material";
import * as React from "react";
import {Link} from "react-router-dom";

const FooterItemList = ({title, item}) => {

    return (

            <Stack color={'white'} spacing={1.5} height={100}
                   sx={{marginBottom : '40px !important', marginLeft : '0px !important'}} alignItems={'center'}
            >
                <Typography variant={'subtitle16'}>{title}</Typography>
                <img src={`/assets/img/rectangle.png`} alt="rectangle" style={{width:60, height: 4}}/>
                {
                    item.map((item) => {
                        return <a href={`${item[1]}`} style={{color:'white', textDecoration:'none'}}>
                            <Typography sx={{cursor:'pointer'}} variant={"subtitle17"} >
                            {item[0]}
                        </Typography></a>
                    })
                }
            </Stack>

    )
}

export default FooterItemList;
